<!--
* UIID: UI-XMB-110
* UI Name: Load/Save File
* Modify Date: 2022/06/06
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{options.item.data.mode == 'Load' ? $t('lbl.mapBuilder.loadFile.loadFileHeader') : $t('lbl.mapBuilder.loadFile.saveFileHeader')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <!-- [S]  Popup title-->
    <v-card-text class="info-section child-table-top-header pb-0">
      <v-row class="analys-top-tool">
        <v-col cols="12" sm="12" class="load-file-title">
          <button
            type="button"
            class="v-icon notranslate v-treeview-node__toggle v-icon--link mdi mdi-menu-down theme--light v-treeview-node__toggle--open"
          ></button>
          <span class="float-left">
            <span class="subheader-text">/{{this.$cookies.get('user-id')}}</span>
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- [E]  Info-->
    <v-card-text class="data-section pt-0">
      <!-- [S]  Tree view and table-->
      <v-row class="ma-0 edi-data-mb">
        <v-col cols="12" class="pt-0 pb-0 pd-grid-left">
          <v-row>
            <!-- [S]  Tree view-->
            <v-col cols="12" sm="4" class="pt-0 pr-3 pb-0">
              <v-row class="tree-panel edi-wrap-content-left">
                <v-col
                  cols="12"
                  class="text-left pa-0 pr-3 pb-2 display-flex top-tool-load-file top-tool-folder"
                >
                  <div class="title-grip-load-file">
                    <v-label class>{{$t('lbl.mapBuilder.loadFile.folderSection')}}</v-label>
                  </div>
                  <div>
                    <v-text-field
                      v-model="searchLeft"
                      :placeholder="$t('lbl.mapBuilder.loadFile.searchFolderPlaceHolder')"
                      class="search-matched-map-list-button custom-form-component search-button edi-analyzed-search"
                      append-icon="fas fa-search"
                      outlined
                      height="30"
                      dense
                      solo
                      hide-details
                    ></v-text-field>
                  </div>
                  <div class="display-flex">
                    <v-btn small text icon @click="deleteFolder">
                      <icon-svg iconName="delete" />
                    </v-btn>
                    <v-btn small text icon @click="addFolder">
                      <icon-svg iconName="add" />
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="pb-1 col-tree">
                  <v-row class="no-gutters">
                    <v-treeview
                      v-model="tree"
                      :search="searchLeft"
                      :items="treeItems"
                      :item-key="'id'"
                      :selection-type="'independent'"
                      @input="onSelectTreeItem"
                      @update:active="updateActive"
                      class="analyzedTree custom-tree"
                      ref="folderTreeView"
                      selectable
                      return-object
                      activatable
                    >
                      <template v-slot:label="{item, open}">
                        <div
                          v-if="item.status != 'added'"
                          :class="['group-has-children-item', 'display-flex']"
                          @contextmenu.stop="show($event,item)"
                        >
                          <v-icon
                            small
                            v-if="open && item.children.length > 0"
                            @click.stop="openItemClick(item, false)"
                            class="mr-1"
                          >fas fa-caret-down</v-icon>
                          <v-icon
                            small
                            v-if="!open && item.children.length > 0"
                            @click.stop="openItemClick(item, true)"
                            class="mr-1"
                          >fas fa-caret-right</v-icon>
                          <v-icon small class="folder-icon mr-1" color="#FFE792">fas fa-folder</v-icon>
                          <div
                            v-if="textItem == 'Rename' && item.id == check"
                            class="group-has-children-item display-flex"
                            @click.stop="preventActive"
                          >
                            <v-text-field
                              :ref="'folder'+item.id"
                              :color="textfolderColor"
                              v-model="item.name"
                              class="new-folder-text-field"
                              dense
                              solo
                              hide-details
                              outlined
                            ></v-text-field>
                            <v-btn
                              small
                              text
                              icon
                              @click.stop="saveTreeFolderItem(item)"
                              class="ml-1 d-inline-flex"
                            >
                              <v-icon color="manager-col-modify darken-1" small>fas fa-save</v-icon>
                            </v-btn>
                            <v-btn
                              small
                              text
                              icon
                              @click.stop="cancelSaveTreeFolderItem(item)"
                              class="ml-0 d-inline-flex"
                            >
                              <v-icon color="popup-col-delete darken-1" small>far fa-window-close</v-icon>
                            </v-btn>
                          </div>
                          <div v-else>{{item.name}}</div>
                        </div>
                        <div
                          v-if="item.status == 'added'"
                          class="group-has-children-item display-flex"
                          @contextmenu.stop="show($event,item)"
                          @click.stop="preventActive"
                        >
                          <v-icon small class="mr-1">fas fa-folder</v-icon>
                          <v-text-field
                            :ref="'folder'+item.id"
                            :color="textfolderColor"
                            v-model="item.name"
                            class="new-folder-text-field"
                            dense
                            solo
                            hide-details
                            outlined
                          ></v-text-field>
                          <v-btn
                            small
                            text
                            icon
                            @click="saveTreeFolderItem(item)"
                            class="ml-1 d-inline-flex"
                          >
                            <v-icon color="manager-col-modify darken-1" small>fas fa-save</v-icon>
                          </v-btn>
                          <v-btn
                            small
                            text
                            icon
                            @click="cancelSaveTreeFolderItem(item)"
                            class="ml-0 d-inline-flex"
                          >
                            <v-icon color="popup-col-delete darken-1" small>far fa-window-close</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <template v-slot:append="{ item }">
                        <div
                          v-if="item.status != 'added' && item.id == '0000000000'"
                          :class="['group-has-children-item', 'display-flex', item.id]"
                        >
                          <v-btn
                            class="expand-all-tree-view-button"
                            @click="expandAllTreeView($event)"
                            dark
                            x-small
                          >{{expand}}</v-btn>
                        </div>
                      </template>
                    </v-treeview>
                    <!-- 
                      203665 2021/01/12 common issue 27 update context menu
                    -->
                    <v-menu
                      v-model="showMenu"
                      :position-x="x"
                      :position-y="y"
                      absolute
                      offset-y
                      content-class="file-menu-context"
                    >
                      <v-list flat>
                        <v-list-item-group>
                          <v-list-item
                            v-for="(item, i) in contexts"
                            :key="i"
                            @click="menuAction(item)"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-text="item.text"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  Tree view-->

            <!-- [S]  Table-->
            <v-col cols="12" sm="8" class="pt-0 pl-5 pb-0 edi-table-section">
              <v-row class="table-panel ml-0 edi-wrap-content-right">
                <v-col class="pa-0" cols="12">
                  <v-row class="analys-top-tool child-table-top-header">
                    <v-col
                      cols="12"
                      sm="12"
                      class="text-left pb-0 display-flex top-tool-load-file pl-4"
                    >
                      <div class="title-grip-load-file">
                        <v-label>{{$t('lbl.mapBuilder.loadFile.fileSection')}}</v-label>
                      </div>
                      <div>
                        <v-text-field
                          v-model="search"
                          @keyup.enter="onFilterAnalyzed"
                          @input="onFilterAnalyzed"
                          @click:append="onFilterAnalyzed"
                          :placeholder="$t('lbl.mapBuilder.loadFile.searchFieldPlaceHolder')"
                          class="search-matched-map-list-button custom-form-component search-button edi-analyzed-search"
                          append-icon="fas fa-search"
                          outlined
                          height="30"
                          dense
                          solo
                          hide-details
                        ></v-text-field>
                      </div>
                      <div>
                        <v-select
                          v-model="searchBy"
                          :items="searchByItems"
                          @change="onFilterAnalyzed"
                          :placeholder="$t('lbl.mapBuilder.loadFile.searchTypePlaceHolder')"
                          class="data-table-select-box custom-selectbox search-selectbox"
                          height="30"
                          hide-details
                          dense
                          solo
                        ></v-select>
                      </div>
                      <div>
                        <v-btn small text icon @click="deleteFile">
                          <icon-svg :disabled="!$auth.manage" iconName="delete" />
                        </v-btn>
                        <!-- <v-btn small text icon @click="enableEditFile">
                          <v-icon color="manager-col-modify darken-1" small>fa fa-pen</v-icon>
                        </v-btn>-->
                        <!--
                          2020/01/20 203665 issue common 27 addd copy function 
                        -->
                        <v-btn small text icon @click="copyOrMoveFile('copy')" ref="copyBtn">
                          <icon-svg :disabled="!$auth.manage" iconName="copy" />
                        </v-btn>
                        <v-btn small text icon @click="copyOrMoveFile('move')" ref="moveBtn">
                          <icon-svg :disabled="!$auth.manage" iconName="cut" />
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="pa-0 pb-1" cols="12" sm="12">
                  <v-row class="pa-4 pt-0 pb-0">
                    <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
                    <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
                    <v-table
                      :height="275"
                      :isMinHeight="isMinHeight"
                      :title-row-height="30"
                      :table-bg-color="'#fafcff'"
                      :title-rows="titleRows"
                      :columns="columns"
                      :table-data="fileData"
                      :column-cell-class-name="columnCellClass"
                      :errorContent="'No matching records found'"
                      :is-loading="showLoading"
                      :select-all="selectAll"
                      :select-change="selectChange"
                      :lazy-loading="lazy_loading"
                      :row-dblclick="preventActive"
                      class="analyzed-view-table load-file-tree-table"
                      ref="edi_analyzed_table"
                      is-horizontal-resize
                      row-hover-color="#eee"
                      row-click-color="#edf7ff"
                      width="100%"
                    >
                      <!-- 
                      203665 2021/01/12 common issue 27 update context menu
                      -->
                      <template v-slot:FILE_NAME=" { item } ">
                        <div v-if="item.SYSSTATUS != ''" style="display:flex">
                          <v-text-field
                            :ref="'fileName'+item.FILE_ID"
                            :color="textfieldColor"
                            v-model="item.FILE_NAME"
                            class="file-name-text-field search-button-data-analysis-table pt-1"
                            heigth="30"
                            outlined
                            hide-details
                            dense
                            solo
                            autofocus
                            oninput="value=value.replace(/[^a-zA-Z\d\-_.()]/g,'')"
                          ></v-text-field>
                          <v-btn
                            small
                            text
                            icon
                            @click="editFileName(item)"
                            class="ml-1 mt-1 d-inline-flex"
                          >
                            <v-icon color="manager-col-modify darken-1" small>fas fa-save</v-icon>
                          </v-btn>
                          <v-btn
                            small
                            text
                            icon
                            @click="cancelFileName(item)"
                            class="ml-0 mt-1 d-inline-flex"
                          >
                            <v-icon color="popup-col-delete darken-1" small>far fa-window-close</v-icon>
                          </v-btn>
                        </div>
                        <span
                          class="font-weight-bold load-file-column"
                          @contextmenu.stop="showContextFile($event , item)"
                        >{{item.FILE_NAME}}</span>
                      </template>
                      <!--  
                      203665 2021/01/18 common issue 27 update contextmenu for table
                      -->
                      <template v-slot:UPD_DT=" { item } ">
                        <span
                          class="font-weight-bold load-file-column"
                          @contextmenu.stop="showContextFile($event , item)"
                        >{{item.UPD_DT}}</span>
                      </template>
                      <template v-slot:FILE_TYPE=" { item } ">
                        <span
                          class="font-weight-bold load-file-column"
                          @contextmenu.stop="showContextFile($event , item)"
                        >{{item.FILE_TYPE}}</span>
                      </template>
                      <template v-slot:USR_FILE_SIZE=" { item } ">
                        <span
                          class="font-weight-bold load-file-column"
                          @contextmenu.stop="showContextFile($event , item)"
                        >{{item.USR_FILE_SIZE}}</span>
                      </template>
                      <template v-slot:FILE_STATUS=" { item } ">
                        <span
                          class="font-weight-bold load-file-column"
                          @contextmenu.stop="showContextFile($event , item)"
                        >{{item.FILE_STATUS}}</span>
                      </template>
                    </v-table>
                    <!-- 
                      203665 2021/01/18 common issue 27 update context menu for table
                    -->
                    <v-menu
                      v-model="showMenuFile"
                      :position-x="x"
                      :position-y="y"
                      absolute
                      offset-y
                      content-class="file-menu-context"
                    >
                      <v-list flat>
                        <v-list-item-group>
                          <v-list-item
                            v-for="(item, i) in contextsFile"
                            :key="i"
                            @click="fileMenuAction(item)"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-text="item.text"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  Table-->
          </v-row>
        </v-col>
      </v-row>
      <!-- [E]  Tree view and table-->

      <!-- [S]  Buttons-->
      <v-row class="ma-0">
        <v-col class="pa-0 text-left" cols="4"></v-col>
        <v-col class="bottom-tool-load-file pr-0" cols="8">
          <v-row class="ma-0" style="height: 45px;">
            <v-col class="pa-0 display-flex">
              <div>
                <v-label>{{$t('lbl.mapBuilder.loadFile.fileName')}}</v-label>
              </div>
              <div class="flatfile-input flatfile-layout-hd">
                <!-- 203705_Server File System[UI-DLB-MBL-110]_Issues [9,14] -->
                <v-text-field
                  v-model="file_name"
                  oninput="value=value.replace(/[^a-zA-Z\d\-_.()]/g,'')"
                  class="input-fl input-content"
                  type="text"
                  solo
                  hide-details
                ></v-text-field>
                <input
                  @change="onAttachFileChanged"
                  id="attach_file_input"
                  type="file"
                  ref="attach_file_input"
                  style="display: none"
                />
              </div>
              <div>
                <v-btn
                  class="btn btn-search open-btn"
                  v-if="options.item.data.mode == 'Load'"
                  @click="openLoadFile"
                  color="primary"
                  dark
                >
                  <!-- <v-icon small color="white" class="mr-1">fas fa-folder-open</v-icon> -->
                  {{$t('btn.common.open')}}
                </v-btn>
                <v-btn
                  class="btn btn-search"
                  v-if="options.item.data.mode != 'Load'"
                  @click="saveInputFile"
                  color="primary"
                  dark
                >
                  <!-- <v-icon small color="white" class="mr-1">fa fa-save</v-icon> -->
                  {{$t('btn.common.save')}}
                </v-btn>
                <!-- <v-btn class="btn btn-close mdl-10" dark @click="removeDialog" >
                  <v-icon small color="white" class="mr-1">fa fa-times</v-icon>
                  {{$t('btn.common.close')}}
                </v-btn>-->
              </div>
              <div>
                <v-btn class="btn btn-delete ml-2 mr-0" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- [E]  Buttons-->
    </v-card-text>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.noSelectItem')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningDeleteFolder"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.noSelectFolder')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningOpenFileDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.warningOpen')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningFolderSaveFileDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.selectFolder')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningAddNewFolderDialog"
      size="max"
      title="Warning"
      detail="Please select folder"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningFileNameSaveFileDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.noInputFileName')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDialog"
      size="max"
      title="Confirm"
      :detail="$t('msg.common.infoConfirm.detail',['delete the folder'])"
      color="confirmation"
      @select-ok="okDeleteFolder"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      title="Confirm"
      :detail="$t('msg.common.infoConfirm.detail',['delete the file'])"
      color="confirmation"
      @select-ok="okDeleteFile"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="saveDuplicateFileNameDialog"
      size="max"
      title="Confirm"
      :detail="$t('msg.common.infoConfirm.duplicate')"
      color="confirmation"
      @select-ok="okSaveDuplicate"
      :showCancel="true"
    ></dialogWindow>
    <!-- 203705_Server File System[UI-DLB-MBL-110]_Issues [9,14] -->
    <dialogWindow
      ref="confirmInputFileDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.confirmInputFile')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="copyInfoDialog"
      size="max"
      title="Confirm"
      :detail="$t('msg.mapBuilder.loadFile.copyInfomation')"
      color="confirmation"
      @select-ok="queryRighttList(activeFolder)"
    ></dialogWindow>
    <dialogWindow
      ref="moveInfoDialog"
      size="max"
      title="Confirm"
      :detail="$t('msg.mapBuilder.loadFile.moveInfomation')"
      color="confirmation"
      @select-ok="queryRighttList(activeFolder)"
    ></dialogWindow>
    <dialogWindow
      ref="warningExistFileMove"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.warningExistFileMove')"
      color="validation"
      @select-ok="closewWarningExistFileMove"
    ></dialogWindow>
    <!-- 2020/01/13 203665 Can edit one file name  -->
    <dialogWindow
      ref="warningEditFileNameDialog"
      size="max"
      title="Warning"
      :detail="$t('msg.mapBuilder.loadFile.warningEditFileName')"
      color="validation"
      :dataValue="dataValue"
      @select-ok="okWarningRenameFileDialog"
      @select-close="closeWarningRenameFileDialog"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="warningFileNameFormat"
      size="max"
      title="Warning"
      :detail="$t('msg.xmlMapBuilder.warningFileNameFormat')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningFileNameExtension"
      size="max"
      title="Warning"
      :detail= warningExtentionDetail
      color="validation"
    ></dialogWindow>
    <!-- 2020/11/06 203737 Remove unused source
      <dialogWindow
        ref="successDialog"
        size="max"
        title="Successful"
        :detail="$t('msg.mapBuilder.loadFile.addSuccess')"
        color="success"
      >
    </dialogWindow>-->
  </dialog-drag>
</template>
<script>
/* globals Store */
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
/* 2020/11/06 203737 Remove unused source
import { debounce } from "lodash";*/
import { get } from "lodash";
import { cloneDeep } from "lodash";
import { mapState } from "vuex";
/* 2020/11/06 203737 Remove unused source
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';*/
import { FolderTreeParser } from "@/vue-dlb/utils/foldtree_parser";
import $ from "jquery";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
// 2021.12.06 SPKA-297 svg icon
import IconSvg from "@/vue-caas/components/IconBase.vue";
import { returnStatement } from 'babel-types';

const msgtreeParser = new FolderTreeParser();
/* 2020/11/06 203737 Remove unused source
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";*/

export default {
  components: {
    dialogWindow,
    DialogDrag,
    SystemProgress,
    IconSvg,
  },
  /* 2020/10/29 203737 Change prop definitions
  props: ['id', 'title', 'options', 'eventCb','selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','fileSelected', 'prs'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    prs: Object,
  },
  data() {
    return {
      warningExtentionDetail: "",
      textItem: "",
      fileTextItem: "",
      check: null,
      x: 0,
      y: 0,
      contexts: [
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.rename") },
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.delete") },
      ],
      /*   
        203665 2021/01/18 common issue 27 update contextmenu for table
      */
      contextsFile: [
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.rename") },
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.copy") },
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.move") },
        { text: this.$t("lbl.mapBuilder.loadFile.contextMenu.delete") },
      ],
      showMenu: false,
      showMenuFile: false,
      result: [],
      selectedFinalItem: "",
      listFileName: [],
      openAll: false,
      isMinHeight: true,
      expand: "Expand All",
      searchLeft: "",
      copyArr: [],
      checkToMove: true,
      action : "",
      /* 2020/11/06 203737 Remove unused source
      checkList: [],
      selectedCheckBoxCnt: 0,
      pageTitle: 'EDI Analyzed View',
      head_title: '',
      checkedColor:"#75C7AF",
      unCheckedColor:'#BFCBD9',
      toggleButton: "#FFFFFF",
      gridListViewBtn: false,
      switch_used: false,
      switch_text: false,
      switch_must: false,
      findFilterValue: '',*/
      segmentFilterValue: "",
      tree: [],
      treeItems: [],
      lazy_loading: true,
      filterQuery: {
        not_used: false,
        qualifier: false,
      },
      file_name: "",
      /* 2020/11/06 203737 Remove unused source
      numberFormatter: new Intl.NumberFormat('en-US'),
      expandAll: false,*/
      dialog: false,
      showLoading: false,
      open: ["ROOT"],
      foldList: [],
      fileList: [],
      /* 2020/11/06 203737 Remove unused source
      query: '',
      searchMessageItems: {
        header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
        data: [{
          CUST_ID: '',
          STR_SNDR: '',
          STR_RCVR: '',
          MSG_ID: '',
          MSG_VER: '',
          DAT_TYPE: '',
          FR_DAT: '',
          TO_DAT: '',
          PRCS_STS: '',  // in case of DataAnalysis Tree selects all status data
          LAY_PRCS_NO: '',
          ALIAS: '',
        }]
      },
      searchLayoutItems: {
        header: ['MSG_ID','MSG_VER','LAY_PRCS_NO'],
        data: [{
          MSG_ID: '',
          MSG_VER: '',
          LAY_PRCS_NO: ''
        }]
      },*/
      addFolderHeader: {
        header: ["PA_FOLD_ID", "PA_FOLD_LVL", "FOLD_NAME"],
        data: [
          {
            PA_FOLD_ID: "",
            PA_FOLD_LVL: "",
            FOLD_NAME: "",
          },
        ],
      },
      updateFolderHeader: {
        header: ["FOLD_NAME", "FOLD_ID"],
        data: [
          {
            FOLD_NAME: "",
            FOLD_ID: "",
          },
        ],
      },
      deleteFolderHeader: {
        header: ["USER_ID", "FOLD_ID"],
        data: [
          {
            USER_ID: "",
            FOLD_ID: "",
          },
        ],
      },
      deleteFileHeader: {
        header: ["USER_ID", "FILE_ID"],
        data: [
          {
            USER_ID: "",
            FOLD_ID: "",
          },
        ],
      },
      moveFileHeader : [],
      /* 2020/11/06 203737 Remove unused source
      openFileHeader : {
        header: ['FILE_ID'],
        data: [{
          FILE_ID: '',
        }]
      },*/
      saveItemsParams: {
        header: [
          "SYSSTATUS",
          "USER_ID",
          "FOLD_ID",
          "FILE_ID",
          "FILE_NAME",
          "USR_FILE_SIZE",
          "FILE_TYPE",
          "USR_FILE_KIND",
        ],
        data: [
          {
            SYSSTATUS: "",
            USER_ID: "",
            FOLD_ID: "",
            FILE_ID: "",
            FILE_NAME: "",
            USR_FILE_SIZE: "",
            FILE_TYPE: "",
            USR_FILE_KIND: "",
            file: "",
          },
        ],
      },
      updateFileNameParams: {
        header: [
          "SYSSTATUS",
          "USER_ID",
          "FOLD_ID",
          "FILE_ID",
          "FILE_NAME",
          "USR_FILE_SIZE",
          "FILE_TYPE",
          "USR_FILE_KIND",
        ],
        data: [
          {
            SYSSTATUS: "",
            USER_ID: "",
            FOLD_ID: "",
            FILE_ID: "",
            FILE_NAME: "",
            USR_FILE_SIZE: "",
            FILE_TYPE: "",
            USR_FILE_KIND: "",
          },
        ],
      },
      /* 2020/11/06 203737 Remove unused source
      insertLayoutMaster: {
        header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','PRCS_STS','LAY_PRCS_NO'],
        data: [{
          CUST_ID: '',
          STR_SNDR: '',
          STR_RCVR: '',
          MSG_STD: '',
          MSG_ID: '',
          MSG_VER: '',
          DAT_TYPE: '',
          FR_DAT: '',
          TO_DAT: '',
          PRCS_STS: '',
          LAY_PRCS_NO: ''
        }]
      },
      insertLayoutData: {
        header: ['SYSSTATUS','ROWID','ELEM_VAL','GRP','ELEM_ID','CNT','CODE_YN','SELE_YN','SEG_ELEM','ESDATAELEM',
                'ESDATANAME','EFDHTYPE','EFLOOP_INDEX','ESNOELEM','POS','EFSEGMENT_ID','EFMAX_USE',
                'ESREQUIRE','EFDHMAXIMUM','EFLOOP_LEVEL','ELEM_NO','SEQ','EFLOOP_ID','EFCODEDEFIN'],
        data: []
      },*/
      titleRows: [
        [
          { fields: ["SELE_YN"], title: "", titleAlign: "center", rowspan: 1 },
          {
            fields: ["FILE_NAME"],
            title: this.$t("tbl.mapBuilder.loadFile.fileName"),
            titleAlign: "center",
            rowspan: 1,
          },
          {
            fields: ["UPD_DT"],
            title: this.$t("tbl.mapBuilder.loadFile.dateTime"),
            titleAlign: "center",
            rowspan: 1,
          },
          {
            fields: ["FILE_TYPE"],
            title: this.$t("tbl.mapBuilder.loadFile.type"),
            titleAlign: "center",
            rowspan: 1,
          },
          {
            fields: ["USR_FILE_SIZE"],
            title: this.$t("tbl.mapBuilder.loadFile.size"),
            titleAlign: "center",
            rowspan: 1,
          },
          {
            fields: ["FILE_STATUS"],
            title: this.$t("tbl.mapBuilder.loadFile.status"),
            titleAlign: "center",
            rowspan: 1,
          },
        ],
      ],
      /*   
        203665 2021/01/18 common issue 27 update contextmenu for table
      */
      columns: [
        {
          field: "SELE_YN",
          width: 40,
          customSlot: true,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection",
        },
        {
          field: "FILE_NAME",
          width: 270,
          customSlot: true,
          columnAlign: "left",
        },
        {
          field: "UPD_DT",
          width: 130,
          customSlot: true,
          columnAlign: "center",
        },
        {
          field: "FILE_TYPE",
          width: 60,
          customSlot: true,
          columnAlign: "left",
        },
        {
          field: "USR_FILE_SIZE",
          width: 60,
          customSlot: true,
          columnAlign: "right",
        },
        {
          field: "FILE_STATUS",
          width: 100,
          isResize: true,
          customSlot: true,
          columnAlign: "left",
        },
      ],
      tableData: [],
      fileData: [],
      selectTreeItems: [],
      /* 2020/11/06 203737 Remove unused source
      selectTreeItem: null,
      openItems: [],*/
      activeFolder: null,
      isEditFileName: false,
      foldId: {
        id: "",
      },
      leftItems: {
        FOLD_ID: "",
      },
      rightItems: {
        FOLD_ID: "",
      },
      checkItems: {
        FOLD_ID: "",
      },
      codeSearchItems: {
        header: ["GRP_CODE"],
        data: [
          {
            GRP_CODE: "",
          },
        ],
      },
      codeItem: [],
      /* 2020/10/28 203737 Remove unused source
      arrStatus: [
        {value: "CRET", text : "Saved"},
        {value: "BDER", text : "Compile Error"},
        {value: "BDCO", text : "Compiled"},
        {value: "EXCO", text : "Executed"}
      ],*/
      search: "",
      searchBy: "all",
      isCopy: false,
      isMove: false,
      textfieldColor: "primary",
      textfolderColor: "primary",
      fileOriginData: "",
      searchByItems: [
        { value: "all", text: "Select Search Item" },
        { value: "FILE_NAME", text: "File Name" },
        { value: "UPD_DT", text: "Date / Time" },
        { value: "FILE_TYPE", text: "Type" },
        { value: "USR_FILE_SIZE", text: "Size" },
        { value: "FILE_STATUS", text: "Status" },
      ],
      dataValue: {
        selectOkFile: "",
        selectCloseFile: "",
      },
      isLoading: true,
    };
  },
  computed: {

    
    /* 2020/10/28 203737 Remove unused source
    ...mapState("layout", {
      segItems: "segItems",
      segTableItems: "segTableItems",
      layoutWindowParam: "layoutWindowParam"
    }),*/
    // ...mapState("dbMapperTest", {
      // foldList: "foldList",
      // xmlFileList: "xmlFileList",
      // fileListCheck: "fileListCheck",
    // }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState("common", {
      codeList: "codeList",
      fileContent: "fileContent",
      sysloadingTitle: "sysloadingTitle",
    }),
    /* 2020/11/06 203737 Remove unused source
    textColor() {
      return this.color + '--text';
    },
    maxWidth() {
      return this.size == 'min' ? 250 : 350;
    },
    headers() {
      return [
        {text : "", value: "SELE_YN"},
        {text : "Seg.", value: "EFSEGMENT_ID"},
        {text : "Element", value: "ESDATAELEM"},
        {text : "Element Name", value: "ESDATANAME"},
        {text : "Req.", value: "ESREQUIRE"},
        {text : "Type", value: "EFDHTYPE"},
        {text : "Size", value: "EFDHMAXIMUM"},
        {text : "Value", value: "ELEM_VAL", filter: this.valueTypeFilter, },
        {text : "Count", value: "CNT", filter: this.oneValueFilter, },
        {text : "Value Info.", value: "EFCODEDEFIN", width:"100px"},
        {text : "Element Biz. ID", value: "ELEM_ID", filter: this.segmentFilter, width:"200px"},
        {text : "MIG Name", value: "SEG_ELEM", width:"100px"}
      ]
    },*/
  },
  watch: {
    dialog() {
      this.dialog ? this.$emit("disable-close") : this.$emit("enable-close");
    },
    fileData() {
      this.$refs.edi_analyzed_table.$forceUpdate();
    } 
      
  },
  mounted() {},
  methods: {
    checkFileNameisNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        this.$refs.warningFileNameFormat.dialog = true;
      } else {
        return true;
      }
    },
    async menuAction(item) {
      this.textItem = item.text;
      if (this.textItem == "Delete") {
        this.deleteFolder();
      } else if (this.textItem == "Rename") {
        let selectTree = this.activeFolder;
      } else if (this.textItem == "Paste") {
        /* 
      203665 2021/01/12 common issue 27 update move file function
      */
        if (this.isCopy) {
          await this.getFileById();
          await this.copyToFolder();
          this.tableData = [];
          this.copyArr = [];
          this.contexts.pop();
          this.activeFolder = this.findFolderById(this.treeItems, this.check);
          this.queryRighttList(this.activeFolder);
          this.file_name = "";
        } else if (this.isMove) {
          await this.getFileById();
          if (this.checkToMove) {
            await this.moveToFolder();
            this.tableData = [];
            this.copyArr = [];
            this.contexts.pop();
            this.activeFolder = this.findFolderById(this.treeItems, this.check);
            this.queryRighttList(this.activeFolder);
            this.file_name = "";
          } else {
            this.$refs.warningExistFileMove.dialog = true;
          }
        }
      }
    },
    /* 
      203665 2021/01/18 common issue 27 update contextmenu for table
    */
    fileMenuAction(item) {
      this.fileTextItem = item.text;
      if (this.fileTextItem == "Delete") {
        this.deleteFile(this.tableData);
      } else if (this.fileTextItem == "Rename") {
        this.enableEditFile();
      } else if (this.fileTextItem == "Copy") {
        this.copyOrMoveFile("copy");
      } else if (this.fileTextItem == "Move") {
        this.copyOrMoveFile("move");
      }
    },

    show(e, item) {
      e.preventDefault();
      this.check = item.id;
      if (this.check == undefined) {
        this.showMenu = false;
        return;
      } else {
        this.textItem = "";
        this.$refs.folderTreeView.updateActive(this.check, true);
        this.showMenu = true;
        this.showMenuFile = false;
        this.x = e.clientX;
        this.y = e.clientY;
      }
    },
    /* 
      203665 2021/01/18 common issue 27 update contextmenu for table
    */
    showContextFile(e, item) {
      if (item === undefined) {
        this.showMenuFile = false;
        return;
      } else {
        e.preventDefault();
        this.fileTextItem = "";
        this.tableData = [];
        let rowItem = [item];
        this.selectChange(rowItem, true);
        this.showMenu = false;
        this.showMenuFile = true;
        this.x = e.clientX;
        this.y = e.clientY;
      }
    },
    // 2020/11/27 203737 Fix isssue 31 move to folder where the last file was opened
    findParent(parentnode, id, result) {
      if (parentnode.id == id) {
        this.result.push(parentnode.parentid);
        return true;
      }
      if (parentnode.children) {
        for (var i = 0; i < parentnode.children.length; i++) {
          var node = parentnode.children[i];
          if (this.findParent(node, id, result)) {
            this.result.push(parentnode.parentid);
            return true;
          }
        }
      }
      return false;
    },
    findFolderById(array, id) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.id === id) {
          return element;
        } else {
          if (element.children) {
            const found = this.findFolderById(element.children, id);
            if (found) {
              return found;
            }
          }
        }
      }
    },
    /* 2020/10/28 203737 Remove unused source
    getStatusText(value) {
      for (let i = 0; i < this.arrStatus.length; i++) {
        let item = this.arrStatus[i];
        if (item.value == value) {
          return item.text;
        }
      }
      return '';
    },*/
    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = "B06";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        console.log("--------- Finished to process code List ----------");
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    updateActive(arr) {
      if (arr.length == 0) {
        this.activeFolder = null;
        this.foldId.id = "";
        return;
      }
      if (arr[0].status != "added") {
        this.queryRighttList(arr[0]);
        this.foldId.id = arr[0].id;
        this.activeFolder = arr[0];
      }
    },
    openItemClick(item, open) {
      this.$refs.folderTreeView.updateOpen(item.id, open);
    },
    /* 2020/10/28 203737 Remove unused source
    createCheckbox () {
      this.segTableItems.forEach(rowdata => {
        if (rowdata.SELE_YN === "Y") {
          this.tableData.push(Object.assign(rowdata, {_checked:true}));
          this.selectedCheckBoxCnt++;
        } else {
          this.tableData.push(Object.assign(rowdata, {_checked:false}));
          this.selectedCheckBoxCnt--;
        }
      });
    },*/
    selectAll(selection) {
      this.tableData = selection;
    },
    selectChange(selection, rowData) {
      this.tableData = selection;
      if (selection.length > 0) {
        this.file_name = selection[0].FILE_NAME;
      } else {
        this.file_name = "";
      }
    },
    saveInputFile() {
      console.log("-------SaveNewInFile--------");
      //Get list file name
      this.listFileName = this.fileData.filter(
        (item) => item.FILE_NAME == this.file_name
      );
      if (this.activeFolder == null) {
        this.$refs.warningFolderSaveFileDialog.dialog = true;
        return;
      }

      if (this.file_name == "") {
        this.$refs.warningFileNameSaveFileDialog.dialog = true;
        return;
      }

      const splitFileName  = this.file_name.split(".");
      if (splitFileName[splitFileName.length - 1] !== "xml" && this.options.item.data.filetype === "mapper") {
        this.warningExtentionDetail = "The file's extension must be xml";
        this.$refs.warningFileNameExtension.dialog = true;
        return;
      }

      if (splitFileName[splitFileName.length - 1] !== "json" && this.options.item.data.filetype === "json") {
        this.warningExtentionDetail = "The file's extension must be json";
        this.$refs.warningFileNameExtension.dialog = true;
        return;
      }

      if (this.listFileName.length != 0) {
        this.$refs.saveDuplicateFileNameDialog.dialog = true;
        return;
      }
      // 203705_Server File System[UI-DLB-MBL-110]_Issues [9,14]
      let regexInputName = /^[a-zA-Z\d\-_.()]*$/g;
      if (!regexInputName.test(this.file_name)) {
        this.$refs.confirmInputFileDialog.dialog = true;
      }
      this.saveItemsParams.data[0].FILE_CONTENT = this.saveItemsParams.data[0].file;
      let savefile = this.saveItemsParams.data[0];
      savefile.SYSSTATUS = "I";
      savefile.USER_ID = $cookies.get("user-id");
      savefile.FOLD_ID = this.activeFolder.id;
      savefile.FILE_ID = "";
      savefile.FILE_NAME = this.file_name;
      savefile.USR_FILE_SIZE = new Blob([
        this.options.item.data.content[0],
      ]).size;
      savefile.FILE_TYPE = this.options.item.data.content[1]; //file type
      savefile.USR_FILE_KIND = this.options.item.data.content[3]; //fileKind
      savefile.file = this.options.item.data.content[0]; //file content
      savefile.FILE_CONTENT = this.options.item.data.content[0]; //file content
      Store.dispatch(
        "insertXmlMapBuilderFile",
        savefile
      ).then(() => {
        this.removeDialog({});
        savefile.FILE_ID = this.$store.getters.xmlFileList; 
        this.options.item.data.callback(savefile);
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    /* 2020/10/28 203737 Remove unused source
    selectClose() {
      this.$emit("select-close", this.dataValue);
      this.dialog = false;
    },
    formatNumber(num) {
      return this.numberFormatter.format(num);
    },*/
    // 230705 mapbuilder fix _Issues 19
    expandAllTreeView(e) {
      if (this.result.length != 0) {
        for (let i = this.result.length - 1; i >= 0; i--) {
          this.$refs.folderTreeView.updateOpen(this.result[i], true);
        }
      }
      if (e == undefined) {
        this.$refs.folderTreeView.updateOpen("0000000000", true);
      } else {
        e.stopImmediatePropagation();
        this.openAll = !this.openAll;
        if (this.openAll) {
          this.expand = "Collapse All";
          this.$refs.folderTreeView.updateAll(this.openAll);
        } else {
          this.expand = "Expand All";
          this.$refs.folderTreeView.updateAll(this.openAll);
          this.$refs.folderTreeView.updateOpen("0000000000", true);
        }
      }
    },
    /* 2020/10/28 203737 Remove unused source
    onChangeNotUsed () {
      console.log('onChangeNotUsed clicked !')
       this.filterQuery.qualifier = false;
      //  this.filterQuery.one_value = false;
    },
    async itemClick (item) {
      await this.$nextTick(() => {
        this.showLoading = true;
        this.$refs.edi_analyzed_table.$forceUpdate();
      });
      await this.delay(100);
      await this.$nextTick();
      this.lazy_loading = false;
      await this.$nextTick();
      this.showLoading = false;
      setTimeout(() => {
        for (let i = 0; i < this.segTableItems.length; i++) {
          if (this.segTableItems[i].EFSEGMENT_ID === item.seg) {
            $('.analyzed-view-table .v-table-rightview-special-border').scrollTop(i * 40);
            return;
          }
        }
        alert('Item not exist in table');
      }, 300);
    },
    delay: ms => new Promise(res => {
        setTimeout(res, ms)
      }),

      async loadIt() {
        this.isLoading = true

        // wait for vdom -> dom
        await this.$nextTick()

        // force browser to rerender dom
        // by requesting some property
        // from newly created node
        let width = this.$refs.hey.width

        // wait for some time, of course
        // higher than monitor refresh rate
        await this.delay(40)

        this.isDone = true
        this.isLoading = false
    },*/
    columnCellClass(rowIndex, columnName, rowData) {
      if (columnName == "FILE_STATUS") {
        return `${rowData[columnName].toLowerCase()}-col`;
      }
      return `${columnName.toLowerCase()}-col`;
    },
    /* 2020/10/28 203737 Remove unused source
    changeView(){
        this.gridListViewBtn = !this.gridListViewBtn;
    },*/
    segmentFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.segmentFilterValue) {
        return true;
      }

      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.segmentFilterValue.toLowerCase());
    },
    valueTypeFilter(value) {
      let retVal = true;
      // If this filter has no value we just skip the entire filter.
      if (this.filterQuery.not_used && !this.filterQuery.qualifier) {
        return true;
      }
      if (!value) return false;

      if (!this.filterQuery.not_used) {
        if (value.toLowerCase().includes("not used")) {
          retVal = false;
        }
      }
      if (this.filterQuery.qualifier) {
        if (value.toLowerCase().includes("text")) {
          retVal = false;
        }
      }
      return retVal;
    },
    onSelectTreeItem(item) {
      this.selectTreeItems = item;
    },
    /* 2020/10/28 203737 Remove unused source
    toggleFilter(str) {
        Store.dispatch('layout/toggleValueFilter', {query : this.filterQuery}).then(() => {
          this.tableData= this.segTableItems;
        });
    },*/
    onFilterAnalyzed(str) {
      Store.dispatch("setFilterMapperLoadFile", {
        filter: this.searchBy,
        str: this.search,
      }).then(() => {
        this.fileData = this.$store.getters.xmlFileList;
      });
    },
    queryLeftList() {
      // this.leftItems.data[0].USER_ID = this.$cookies.get("user-id");
      Store.dispatch("getXmlMapBuilderQueryFolderList").then(() => {
        console.log("--------- finished ----------");
        this.foldList = this.$store.getters.xmlFolderList;
        console.log("Xml Foler List",this.foldList)
        this.textfolderColor = "primary";
        // console.log('TREEFile'+JSON.stringify(this.foldList));
        this.treeItems = msgtreeParser.parse(this.foldList);
        this.result = [];
        if (this.options.item.data.filetype == "input") {
          if (this.lastFoldIdInput != "") {
            this.findParent(
              this.treeItems[0],
              this.lastFoldIdInput,
              this.result
            );
          } else {
            this.result = [];
          }
        } else if (this.options.item.data.filetype == "output") {
          if (this.outputFolderId != "") {
            this.findParent(
              this.treeItems[0],
              this.outputFolderId,
              this.result
            );
          } else {
            this.result = [];
          }
        } else if (this.options.item.data.filetype == "scanner") {
          if (this.lastFoldIdScanner != "") {
            this.findParent(
              this.treeItems[0],
              this.lastFoldIdScanner,
              this.result
            );
          } else {
            this.result = [];
          }
        } else if (this.options.item.data.filetype == "inputMap") {
          if (this.lastFoldIdBiz != "") {
            this.findParent(this.treeItems[0], this.lastFoldIdBiz, this.result);
          } else {
            this.result = [];
          }
        } else if (this.options.item.data.filetype == "biz") {
          if (this.bizFolderId != "") {
            this.findParent(this.treeItems[0], this.bizFolderId, this.result);
          } else {
            this.result = [];
          }
        } else if (this.options.item.data.filetype == "mapper") {
          if (this.lastFoldIdMapper != "") {
            this.findParent(
              this.treeItems[0],
              this.lastFoldIdMapper,
              this.result
            );
          } else {
            this.result = [];
          }
        }
      });
    },
    deleteFolder() {
      if (this.selectTreeItems.length == 0) {
        this.$refs.warningDeleteFolder.dialog = true;
      } else {
        this.$refs.confirmDialog.dialog = true;
      }
    },
    okDeleteFolder(check) {
      this.deleteFolderHeader.data = [];
      // 2021.9.24 203728 SPKA-217 get all children folder when delete
      let self = this;
      let checkData = function (value) {
        let chk = self.deleteFolderHeader.data.findIndex(
          (e) => e.FOLD_ID === value
        );
        if (chk < 0)
          self.deleteFolderHeader.data.push({
            USER_ID: self.$cookies.get("user-id"),
            FOLD_ID: value,
          });
      };
      for (let i = 0; i < this.selectTreeItems.length; i++) {
        checkData(this.selectTreeItems[i].id);
        if (this.selectTreeItems[i].children.length > 0) {
          this.selectTreeItems[i].children.map((lv2) => {
            checkData(lv2.id);
            if (lv2.children.length > 0) {
              lv2.children.map((lv3) => checkData(lv3.id));
            }
          });
        }
      }
      // for (let i = 0; i < this.selectTreeItems.length; i++) {
      //   this.deleteFolderHeader.data.push({
      //     USER_ID : this.$cookies.get('user-id'),
      //     FOLD_ID : this.selectTreeItems[i].id
      //   })
      // }
      Store.dispatch(
        "deleteXmlMapBuiderFolder",
        this.deleteFolderHeader.data
      ).then(() => {
        this.queryLeftList();
      });
    },
    /* 
      2020/01/20 203665 issue common 27 update for rename function
    */
    enableEditFile() {
      if (this.tableData.length == 0) {
        this.$refs.warningDialog.dialog = true;
      } else {
        for (const item of this.fileData) {
          if (item.SYSSTATUS === "U") {
            this.dataValue.selectOkFile = item;
            this.dataValue.selectCloseFile = this.tableData[0];
            this.$refs.warningEditFileNameDialog.dialog = true;
            return;
          }
        }
        this.tableData.forEach((item) => (item.SYSSTATUS = "U"));     
        this.file_name = "";
        this.updateDataTable(this.tableData[0]);
        
      }
    },
    /* 
      2020/01/20 203665 issue common 27 update for rename function
    */
    okWarningRenameFileDialog() {
      this.tableData.forEach((item) => (item.SYSSTATUS = "U"));
      this.textfieldColor = "primary";
      this.cancelFileName(this.dataValue.selectOkFile);
      this.updateDataTable(this.tableData[0])    
      // for (const item of this.fileData) {
      //   if(item.FILE_ID === this.dataValue.selectOkFile.FILE_ID){
      //     item.SYSSTATUS = '';
      //     return;
      //   }
      // }
    },
    closeWarningRenameFileDialog() {
      let focusItem = "fileName" + this.dataValue.selectOkFile.FILE_ID;
      setTimeout(() => {
        this.$refs[focusItem].focus();
      }, 200);
      this.fileTextItem = "";
      return;
    },
    /* 
      203665 2021/01/12 common issue 27 update function edit file name
    */
    editFileName(item) {
      if (item.FILE_NAME === "") {
        let focusItem = "fileName" + item.FILE_ID;
        this.textfieldColor = "error";
        setTimeout(() => {
          this.$refs[focusItem].focus();
        }, 200);
        this.fileTextItem = "";
        return;
      }
      this.textfieldColor = "primary";
      let savefile = {};
      savefile.SYSSTATUS = "U";
      savefile.USER_ID = $cookies.get("user-id");
      savefile.FOLD_ID = item.FOLD_ID;
      savefile.FILE_ID = item.FILE_ID;
      savefile.FILE_NAME = item.FILE_NAME;
      savefile.USR_FILE_SIZE = item.USR_FILE_SIZE;
      savefile.FILE_TYPE = item.FILE_TYPE;
      savefile.USR_FILE_KIND = item.USR_FILE_KIND;
      savefile.FILE_STATUS = item.FILE_STATUS;
      this.updateFileNameParams.data[0] = savefile;
      /*   
        203665 2021/01/18 common issue 27 update contextmenu for table
      */
      Store.dispatch(
        "updateXmlMapBuiderFile",
        this.updateFileNameParams.data[0]
      ).then(() => {
        this.queryRighttList(this.activeFolder);
        this.showMenuFile = false;
        this.tableData = [];
        this.file_name = "";
      });
    },
    preventActive() {
      return false;
    },
    /* 
      2020/01/20 203665 issue common 27 update for rename function
    */
    cancelFileName(rowItem) {
      rowItem.SYSSTATUS = "";
      for (const item of this.fileOriginData) {
        if (item.FILE_ID === rowItem.FILE_ID) {
          rowItem.FILE_NAME = item.FILE_NAME;
          this.textfieldColor = "primary";
          this.file_name = "";
          this.updateDataTable(rowItem);
          return;
        }
      }
    },
    // 2022.06.07 213960 reload v-table
    updateDataTable(item){
      this.fileData = []
      this.$store.commit("SET_UPDATE_MAPPER_FILE_LIST", item);
      this.fileData = this.$store.getters.xmlFileList; 
    },
    cancelSaveTreeFolderItem(item) {
      this.textItem = "";
      this.check = "";
      this.queryLeftList();
    },
    deleteFile() {
      if (this.tableData.length == 0) {
        this.$refs.warningDialog.dialog = true;
      } else {
        this.$refs.confirmDeleteFileDialog.dialog = true;
      }
    },
    okDeleteFile() {
      this.deleteFileHeader.data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        this.deleteFileHeader.data.push({
          USER_ID: this.$cookies.get("user-id"),
          FILE_ID: this.tableData[i].FILE_ID,
        });
      }
      /*   
        203665 2021/01/18 common issue 27 update contextmenu for table
      */
      Store.dispatch(
        "deleteXmlMapBuiderFile",
        this.deleteFileHeader.data
      ).then(() => {
        this.queryRighttList(this.activeFolder);
        this.tableData = [];
        this.file_name = "";
      });
    },
    /* 
    203665 2021/01/12 common issue 27 update context menu
    */
    copyOrMoveFile(type) {
      let haveParte = false;
      for (var item of this.contexts) {
        if (item.text === "Paste") {
          haveParte = true;
          break;
        }
      }
      if (!haveParte) {
        this.contexts.push({ text: "Paste" });
      }
      this.copyArr = this.tableData;
      this.file_name = "";
      if (type == "copy") {
        this.isCopy = true;
        this.isMove = false;
        this.$refs.copyInfoDialog.dialog = true;
      } else if (type == "move") {
        this.isCopy = false;
        this.isMove = true;
        this.$refs.moveInfoDialog.dialog = true;
      }
    },
    /* 
      2020/01/20 203665 issue common 27 add copy file function
    */
    async copyToFolder() {
      console.log(this.copyArr)
      for (let i = 0; i < this.copyArr.length; i++) {
        let savefile = {};
        savefile.SYSSTATUS = "I";
        savefile.USER_ID = $cookies.get("user-id");
        savefile.FOLD_ID = this.check;
        savefile.FILE_ID = "";
        savefile.FILE_NAME = this.copyArr[i].FILE_NAME;
        savefile.USR_FILE_SIZE = this.copyArr[i].USR_FILE_SIZE;
        savefile.FILE_TYPE = this.copyArr[i].FILE_TYPE;
        savefile.USR_FILE_KIND = this.copyArr[i].USR_FILE_KIND;
        savefile.file = this.copyArr[i].FILE_CONTENT;
        savefile.FILE_CONTENT = this.copyArr[i].FILE_CONTENT;
        // this.saveItemsParams.data[0] = savefile;
        await Store.dispatch(
          "insertXmlMapBuilderFile",
          savefile
        );
      }
    },
    /* 
    203665 2021/01/12 common issue 27check duplicate file Name
    */
    checkDupCopyArr(checkFileList, copyArr) {
      let arrFile = [...checkFileList, ...copyArr];
      let arrFileName = [];
      for (let item of arrFile) {
        arrFileName.push(item.FILE_NAME);
      }
      let arrFileNameCreated = this.createFileNameCopy(arrFileName);
      for (let i = 0; i < checkFileList.length; i++) {
        arrFileNameCreated.shift();
      }
      for (let i = 0; i < arrFileNameCreated.length; i++) {
        copyArr[i].FILE_NAME = arrFileNameCreated[i];
      }
    },
    createFileNameCopy(arrFileCheck) {
      var item = {},
        t = (name, index) => name + "(" + index + ")";

      return arrFileCheck.map(function (name) {
        var index = item[name] || 0;
        item[name] = index + 1;
        if (!index) return name;

        while (item[t(name, index)]) index++;
        item[t(name, index)] = 1;
        return t(name, index);
      });
    },
    closewWarningExistFileMove() {
      this.checkToMove = true;
      this.tableData = [];
      this.copyArr = [];
      this.contexts.pop();
    },
    /* 
    203665 2021/01/12 common issue 27 update move file function
    */
    async moveToFolder() {
      for (let i = 0; i < this.copyArr.length; i++) {
        this.moveFileHeader = [];
        this.moveFileHeader.push({
          FOLD_SRC_ID: this.copyArr[i].FOLD_ID,
          FOLD_DES_ID: this.check,
          FILE_ID: this.copyArr[i].FILE_ID,
        });
        /*   
          203665 2021/01/18 common issue 27 update contextmenu for table
        */
        await Store.dispatch("moveFile", this.moveFileHeader[0]);
      }
    },
    /*
    203665 2021/01/12 common issue 27check duplicate file Name
    */
    async getFileById() {
      this.checkItems.FOLD_ID = this.check;
      await Store.dispatch(
        "getFileListToCheck",
        this.checkItems
      ).then(() => {
        this.fileListCheck = this.$store.getters.fileListCheck;
        if (this.isMove) {
          for (let i = 0; i < this.copyArr.length; i++) {
            for (let j = 0; j < this.fileListCheck.length; j++) {
              if (this.copyArr[i].FILE_ID === this.fileListCheck[j].FILE_ID) {
                this.checkToMove = false;
                return;
              }
            }
          }
        }
        let checkFileList = this.fileListCheck;
        this.checkDupCopyArr(checkFileList, this.copyArr);
      });
    },
    okSaveDuplicate() {
      let savefile = {};
      savefile.SYSSTATUS = "Saved";
      savefile.USER_ID = $cookies.get("user-id");
      savefile.FOLD_ID = this.activeFolder.id;
      savefile.FILE_ID = this.listFileName[0].FILE_ID;
      savefile.FILE_NAME = this.file_name;
      savefile.USR_FILE_SIZE = new Blob([
        this.options.item.data.content[0],
      ]).size;
      savefile.FILE_TYPE = this.options.item.data.content[1];
      savefile.USR_FILE_KIND = this.options.item.data.content[3];
      savefile.file = this.options.item.data.content[0];
      savefile.FILE_CONTENT = this.options.item.data.content[0];
       savefile.FILE_STATUS = "Saved";
      // this.saveItemsParams.data[0] = savefile;
      console.log("this is update----------->");
      Store.dispatch(
        "updateXmlMapBuiderFile",
        savefile
      ).then(() => {
        this.removeDialog({});
        this.options.item.data.callback(savefile);
      });
    },
    queryRighttList(item) {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      if (this.options.item.data.filetype == "mapper") {
        if (this.lastFoldIdMapper != "") {
          this.rightItems.FOLD_ID = this.lastFoldIdMapper;
        } else if (this.lastFoldIdMapper == "" && item == undefined) {
          this.rightItems.FOLD_ID = "0000000000";
        } else {
          this.rightItems.FOLD_ID = item.id;
        }
        this.rightItems.action = this.action;
      } else if (this.options.item.data.filetype == "json") {
        if (this.lastFoldIdBiz != "") {
          this.rightItems.FOLD_ID = this.lastFoldIdBiz;
        } else if (this.lastFoldIdBiz == "" && item == undefined) {
          this.rightItems.FOLD_ID = "0000000000";
        } else {
          this.rightItems.FOLD_ID = item.id;
        }
      }

      Store.dispatch("getXmlMapBuilderQueryFileList", this.rightItems)
        .then(() => {
          this.textfieldColor = "primary";
          this.fileData = this.$store.getters.xmlFileList;
          // this.fieData.map(e => e.USR_FILE_SIZE = new Blob([e.FILE_CONTENT]).size) 
          if (this.options.item.data.filetype == "input") {
            if (this.lastFoldIdInput != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.lastFoldIdInput
              );
              this.$refs.folderTreeView.updateActive(
                this.lastFoldIdInput,
                true
              );
              this.lastFoldIdInput = "";
            }
          } else if (this.options.item.data.filetype == "output") {
            if (this.outputFolderId != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.outputFolderId
              );
              this.$refs.folderTreeView.updateActive(this.outputFolderId, true);
              this.outputFolderId = "";
            }
          } else if (this.options.item.data.filetype == "scanner") {
            if (this.lastFoldIdScanner != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.lastFoldIdScanner
              );
              this.$refs.folderTreeView.updateActive(
                this.lastFoldIdScanner,
                true
              );
              this.lastFoldIdScanner = "";
            }
          } else if (this.options.item.data.filetype == "inputMap") {
            // 2021.3.16 203728 SPKA-52 => bug 15
            if (this.lastFoldIdBiz != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.lastFoldIdBiz
              );
              this.$refs.folderTreeView.updateActive(this.lastFoldIdBiz, true);
              this.lastFoldIdBiz = "";
            }
          } else if (this.options.item.data.filetype == "biz") {
            // 2021.3.16 203728 SPKA-52 => bug 15
            if (this.bizFolderId != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.bizFolderId
              );
              this.$refs.folderTreeView.updateActive(this.bizFolderId, true);
              this.bizFolderId = "";
            }
          } else if (this.options.item.data.filetype == "mapper") {
            this.fileData = this.fileData.filter(e => e.FILE_TYPE == 'xml')
            if (this.lastFoldIdMapper != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.lastFoldIdMapper
              );
              this.$refs.folderTreeView.updateActive(
                this.lastFoldIdMapper,
                true
              );
              this.lastFoldIdMapper = "";
            }
          } else if (this.options.item.data.filetype == "json") {
            this.fileData = this.fileData.filter(e => e.FILE_TYPE == 'json')
            if (this.lastFoldIdBiz != "") {
              this.activeFolder = this.findFolderById(
                this.treeItems,
                this.lastFoldIdBiz
              );
              this.$refs.folderTreeView.updateActive(this.lastFoldIdBiz, true);
              this.lastFoldIdBiz = "";
            }
          }
          for (let i = 0; i < this.fileData.length; i++) {
            this.fileData[i].SYSSTATUS = ""
            this.fileData[i].USR_FILE_SIZE = new Blob([this.fileData[i].FILE_CONTENT]).size;
          }
          this.fileOriginData = _.cloneDeep(this.fileData);
          this.expandAllTreeView();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    openLoadFile() {
      // 203705_Server File System[UI-DLB-MBL-110]_Issues [9,14]
      let regexInputName = /^[a-zA-Z\d\-_.()]*$/g;
      if (this.tableData.length == 0 || this.tableData.length > 1) {
        this.$refs.warningOpenFileDialog.dialog = true;
      } else if (!regexInputName.test(this.file_name)) {
        this.$refs.confirmInputFileDialog.dialog = true;
      } else if (this.file_name.trim() == "") {
        this.$refs.warningFileNameSaveFileDialog.dialog = true;
      } else {
        this.removeDialog({});
        this.tableData[0].FILE_NAME = this.file_name;
        this.$store.commit("SET_STORE_VIEW_FILE_DATA", this.tableData);
        this.$emit("fileChanged", this.tableData);
        this.options.item.data.callback(this.tableData[0]);
      }
    },
    onAttachFileChanged(e) {
      this.saveItemsParams.data[0].FILE_NAME = e.target.files[0].name;
      this.saveItemsParams.data[0].USR_FILE_SIZE = e.target.files[0].size;
      this.saveItemsParams.data[0].FILE_TYPE = "txt";
      var reader = new FileReader();
      reader.onload = (e) => {
        this.saveItemsParams.data[0].file = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    addFolder() {
      if (this.activeFolder == null) {
        this.$refs.warningAddNewFolderDialog.dialog = true;
        return;
      }

      let selectTree = this.activeFolder;
      selectTree.children.push({
        children: [],
        id: "",
        parentlevel: selectTree.level,
        name: "New Folder",
        parentid: selectTree.id,
        status: "added",
      });
      let treeData = this.treeItems;

      setTimeout(() => {
        this.treeItems = treeData;
        this.$nextTick(() => {
          this.$refs.folderTreeView.updateOpen(this.activeFolder.id, true);
        });
      }, 300);
    },
    /* 
      203665 2021/01/12 common issue 27 update function edit folder name
    */
    saveTreeFolderItem(item) {
      if (item.name === "") {
        let focusItem = "folder" + item.id;
        this.textfolderColor = "error";
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs[focusItem].focus();
          });
        }, 200);
        return;
      }
      this.textfolderColor = "primary";
      if (this.textItem == "Rename") {
        this.updateFolderHeader.data[0].FOLD_NAME = item.name;
        this.updateFolderHeader.data[0].FOLD_ID = item.id;
        Store.dispatch("updateXmlMapBuiderFolder", this.updateFolderHeader.data[0]).then(
          () => {
            this.queryLeftList();
            this.textItem = "";
          }
        );
      } else {
        this.addFolderHeader.data[0].PA_FOLD_LVL = item.parentlevel;
        this.addFolderHeader.data[0].FOLD_NAME = item.name;
        this.addFolderHeader.data[0].PA_FOLD_ID = item.parentid;
        Store.dispatch("insertXmlMapBuiderFolder", this.addFolderHeader.data[0]).then(
          () => {
            this.queryLeftList();
          }
        );
      }
    },
  },
  created() {
    console.log("--------- created ----------");
    this.params = this.prs;
    if (this.options.item.data.mode == "Save") {
      console.log("mode Save");
      this.file_name = this.options.item.data.content[2];
    }
    // this.selectedFinalItem = this.options.item.data.lastFoldId;
    this.lastFoldIdInput = this.options.item.data.lastFoldIdInput;
    this.lastFoldIdScanner = this.options.item.data.lastFoldIdScanner;
    this.lastFoldIdBiz = this.options.item.data.lastFoldIdBiz;
    this.lastFoldIdMapper = this.options.item.data.lastFoldIdMapper;
    this.bizFolderId = this.options.item.data.bizFolderId;
    this.outputFolderId = this.options.item.data.outputFolderId;
    this.action = this.options.item.data.action;
    this.queryLeftList();
    this.queryRighttList();
    this.getCode();
  },
};
</script>
<style>
</style>